import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, getTranslation, languages } from './translations';

const LanguageContext = createContext();

// Detect initial language from URL or default to Spanish
const getInitialLanguage = () => {
  const path = window.location.pathname;
  const langMatch = path.match(/^\/(en|es-es)/);
  
  if (langMatch) {
    return langMatch[1];
  }
  
  // No language in URL - default to Spanish
  return 'es-es';
};

export const LanguageProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(getInitialLanguage);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // If URL doesn't have language prefix, redirect to Spanish version
    const path = window.location.pathname;
    const search = window.location.search;
    const langMatch = path.match(/^\/(en|es-es)/);
    
    if (!langMatch) {
      // Redirect to Spanish version, preserving query params
      const basePath = path === '/' ? '' : path;
      const newPath = `/es-es${basePath}${search}`;
      window.location.replace(newPath); // Use replace for immediate redirect
    }
    setIsInitialized(true);
  }, []);

  const t = (path) => getTranslation(currentLang, path);
  
  const changeLang = (lang) => {
    setCurrentLang(lang);
    // Update URL
    const currentPath = window.location.pathname;
    const pathWithoutLang = currentPath.replace(/^\/(en|es-es)/, '');
    const newPath = `/${lang}${pathWithoutLang || ''}`;
    window.history.replaceState({}, '', newPath);
  };

  const isRTL = languages.find(l => l.code === currentLang)?.rtl || false;

  return (
    <LanguageContext.Provider value={{ currentLang, setLang: changeLang, t, isRTL, languages }}>
      <div dir={isRTL ? 'rtl' : 'ltr'}>
        {children}
      </div>
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
